// extracted by mini-css-extract-plugin
module.exports = {"tabs":"tabs_tabs__6huo-","tab":"tabs_tab__2vydL","active":"tabs_active__3ZPTt"};